import { Component, OnInit } from '@angular/core';
import {FormControl, FormGroup} from '@angular/forms';
import {NationalityModel} from '../../../shared/dto/nationality.model';
import {NgxUiLoaderService} from 'ngx-ui-loader';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {NationalityService} from '../../../shared/service/nationality.service';
import swal from "sweetalert2";
import {ActionMode} from '../../../shared/enums/action-mode.enum';
import {NationalityPopupComponent} from './nationality-popup/nationality-popup.component';
import {TokenStorageService} from '../../../shared/service/token-storage.service';
import {Router} from '@angular/router';

@Component({
  selector: 'app-nationality',
  templateUrl: './nationality.component.html',
  styleUrls: ['./nationality.component.scss']
})
export class NationalityComponent implements OnInit {
  public nationalityForm: FormGroup;
  public nationalityDTO: NationalityModel[] = [];
  public nationalityConfigItems: NationalityModel[] = [];
  public href: string = "";

  constructor(public modalService: NgbModal,
              private spinnerService: NgxUiLoaderService,
              private nationalityService: NationalityService,
              private tokenStorageService: TokenStorageService,
              private router : Router) { }

  ngOnInit() {
    this.nationalityForm = new FormGroup({
      code: new FormControl(null),
      description: new FormControl(null),
      states: new FormControl(null),
    });
    this.href = this.router.url;
    this.getAllNationalities();
    this.onLoadGetData();
  }

  getAllNationalities(){
    this.nationalityService.getAllNationalities().subscribe(
      (data: NationalityModel[]) =>{
        this.nationalityDTO = data;
        this.nationalityConfigItems = data;
      }
    );
  }

  onLoadGetData(): void {
    const nationalityDTO = new NationalityModel(
      null,
      null,
      null,
      null,
      null
    )
    this.loadSearchResultList(nationalityDTO);
  }

  loadSearchResultList(nationalityDTO: NationalityModel): void {
    this.spinnerService.start();
    this.nationalityService.searchNationalityDetails(nationalityDTO).subscribe(
      (data: NationalityModel[]) => {
        this.nationalityConfigItems = data;
      },
      (error) => {
        this.spinnerService.stop();
        swal.fire('Sorry!', 'Something went wrong...!', 'error');
      },
      () => {
        this.spinnerService.stop();
        if (this.nationalityConfigItems == null || this.nationalityConfigItems.length === 0) {
          swal.fire('Sorry', 'No result found.', 'error');
          this.getAllNationalities();
        } else {
          this.nationalityService.clearNationalitySearchDetails();
          this.nationalityService.setNationalitySearchDetails(
            this.nationalityConfigItems
          );
        }
      }
    );
  }

  onSubmitSearch(): void {
    let isValid: boolean = false;
    let msg: string = 'Please fill the form..!';

    if (this.nationalityForm.value.code != null) {
      isValid = true;
    }
    if (this.nationalityForm.value.description != null) {
      isValid = true;
    }
    if (this.nationalityForm.value.states != null) {
      isValid = true;
    }
    if (isValid && this.nationalityForm.valid) {
      const nationalityDTO = new NationalityModel(
        this.nationalityForm.value.code,
        this.nationalityForm.value.description,
        this.nationalityForm.value.states,
        this.tokenStorageService.getUserObjectToken().username,
        this.href
      );
      this.loadSearchResultList(nationalityDTO);
      this.spinnerService.start();
    }
  }

  validateAllFormFields(formGroup: FormGroup) {

    Object.keys(formGroup.controls).forEach(field => {

      const control = formGroup.get(field);
      if (control instanceof FormControl) {

        control.markAsTouched({onlySelf: true});
      } else if (control instanceof FormGroup) {

        this.validateAllFormFields(control);
      }
    });
  }

  onClickReset(){
    this.nationalityForm.reset({
      code: null,
      description: null,
      states: null,
    });
    this.onLoadGetData();
  }

  onClickNew(){
    const modalRef = this.modalService.open(NationalityPopupComponent, {
      windowClass: 'xlModal'
    });
    // modalRef.componentInstance.name = 'Add New Employee';
    modalRef.componentInstance.selectedMode = ActionMode.ADD;
    modalRef.componentInstance.nationalityMgtCopy_ = this.nationalityConfigItems;
    modalRef.result.then((data: string) => {
      if (data == 'Saved') {
        this.onLoadGetData();
      }
    }, () => {

    });
  }

}
